import type { DriveRootSafe } from '@vivport/backend/types';
import { Link } from 'react-router-dom';

type LibraryPanelProps = {
  root: DriveRootSafe;
};

export function LibraryPanel({ root }: LibraryPanelProps) {
  return (
    <div className="space-y-1">
      <p className="text-sm font-medium">Library · {root.path}</p>
      {root.libraryTagGroupId !== null ? (
        <p className="text-xs text-muted-foreground">
          Tag group{' '}
          <Link to={`/work4me/tag-groups/${root.libraryTagGroupId}`} className="underline hover:text-foreground">
            {root.libraryTagName ?? `#${root.libraryTagGroupId}`}
          </Link>{' '}
          · {root.libraryTagCount} tag{root.libraryTagCount === 1 ? '' : 's'}, one per sub-folder. Library files receive tags,
          not a project.
        </p>
      ) : (
        <p className="text-xs text-muted-foreground">
          The tag group is created on the first sync. Library files receive tags, not a project.
        </p>
      )}
    </div>
  );
}
